import { gql } from "@apollo/client"

export const ArtistDetailQuery = gql`
  query ArtistDetailQuery($slug: String!, $userId: ID) {
    artist(slug: $slug, userId: $userId) {
      slug
      name
      genderPronoun
      livesAndWorks
      graduations {
        year
        degreeType
        school {
          name
          city
          state {
            short
          }
          country {
            name
          }
        }
      }
      affiliations {
        organization {
          name
          city
          state {
            short
          }
          country {
            name
          }
        }
      }
      birthYear
      hometown
      website
      contactEmail
      cv
      statement
      artworks(publishedOnly: true) {
        published
      }
      savedByUser(userId: $userId)
    }
  }
`
